import { getUsers } from "common/services/users.service";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { normalize } from "common/lib/normalize";

const LastSignup = () => {
  const [lastSignup, setLastSignup] = useState(new Date().getTime());

  useEffect(() => {
    const fetchLastSignup = async () => {
      const response: any = await getUsers({
        sort: "createdAt:desc",
        pagination: {
          page: 1,
          pageSize: 1,
        },
      });
      const data = normalize(response.data);

      setLastSignup(
        data && data.length > 0
          ? new Date(data[0].createdAt).getTime()
          : new Date().getTime()
      );
    };
    fetchLastSignup();
  }, []);

  return (
    <div className="col">
      <div className="py-4 px-3">
        <h5 className="text-muted text-uppercase fs-13">
          {"Last Signup"}
          <i className={"ri-focus-line fs-18 float-end align-middle"}></i>
        </h5>
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <i className={"ri-time-line display-6 text-muted cfs-22"}></i>
          </div>
          <div className="flex-grow-1 ms-3">
            <h2 className="mb-0 cfs-22">
              <span className="counter-value" data-target="0">
                <CountUp
                  start={0}
                  prefix={""}
                  suffix={""}
                  separator={""}
                  end={lastSignup}
                  decimals={0}
                  duration={0}
                  formattingFn={(value) => {
                    return new Date(value).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    });
                  }}
                />
              </span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastSignup;
